import React from "react";
import styled from "styled-components";

const Count = () => {
	return (
		<Wrapper>
			<div className='container'>
				<div className='row text-center'>
					<div className='col-sm-12'>
						<h4>Trabajamos con</h4>
					</div>
					<div className='col-6 col-md-3'>
						<h2>26</h2>
						<p>Aseguradoras</p>
					</div>
					<div className='col-6 col-md-3'>
						<h2>7,306</h2>
						<p>Clientes Asegurados</p>
					</div>
					<div className='col-6 col-md-3'>
						<h2>369</h2>
						<p>Empresas con Nosotros</p>
					</div>
					<div className='col-6 col-md-3'>
						<h2>1,886</h2>
						<p>Vehículos asegurados</p>
					</div>
				</div>
			</div>
		</Wrapper>
	);
};

export default Count;

const Wrapper = styled.section`
	padding: 20px 0;
	background: #5268c2;
	color: #fff;
	h4 {
		color: #3cdbc0;
	}
	h2 {
		color: #3cdbc0;
		font-size: 50px;
		font-weight: 800;
		margin-bottom: 0;
	}
	p {
		margin-bottom: 0;
	}
	@media (max-width: 767px) {
		padding: 40px 0 20px;
		p {
			margin-bottom: 15px;
		}
	}
`;
